import { useContext } from "react";
import { Context } from "../intersection-observer";

export const useInterSectionObserver = () => {
  const context = useContext(Context);
  return context;
};
